export const OnboardingRoutes = {
  createDemo: '/company/onboarding/create-demo',
  company: '/company/onboarding/general',
  stockLocationImport: '/company/onboarding/stock_locations/import',
  stockLocationAdd: '/company/onboarding/stock_locations/add',
  stockLocationEdit: '/company/onboarding/stock_locations/:id/edit',
  stockLocationOverview: '/company/onboarding/stock_locations/overview',
  referenceDataImport: '/company/onboarding/reference_data/import',
  referenceDataAdd: '/company/onboarding/reference_data/add',
  referenceDataEdit: '/company/onboarding/reference_data/:id/edit',
  referenceDataOverview: '/company/onboarding/reference_data/overview',
  stockImport: '/company/onboarding/stock/import',
  users: '/company/onboarding/users',
} as const;
